import React from 'react';
import { HelpRouterFragment } from './help-router.interface';

interface Props {
    helpRouterContent: HelpRouterFragment;
}

const helpRouterPopularLinks = (props: Props) => {
    return (
        <div className={'help-router-popular-links'}>
            <p>{props.helpRouterContent?.mainMenu.sectionTitle}</p>
            <p>
                <a
                    href={
                        props.helpRouterContent?.mainMenu.recommendedLinks.link1
                            .link1CtaUrlPath
                    }
                    aria-label={
                        props.helpRouterContent?.mainMenu.recommendedLinks.link1
                            .link1AriaLabel
                    }
                >
                    {
                        props.helpRouterContent?.mainMenu.recommendedLinks.link1
                            .link1CtaTitle
                    }
                </a>
            </p>
            <p>
                <a
                    href={
                        props.helpRouterContent?.mainMenu.recommendedLinks.link2
                            .link2CtaUrlPath
                    }
                    aria-label={
                        props.helpRouterContent?.mainMenu.recommendedLinks.link2
                            .link2AriaLabel
                    }
                >
                    {
                        props.helpRouterContent?.mainMenu.recommendedLinks.link2
                            .link2CtaTitle
                    }
                </a>
            </p>
            <p>
                <a
                    href={
                        props.helpRouterContent?.mainMenu.recommendedLinks.link3
                            .link3CtaUrlPath
                    }
                    aria-label={
                        props.helpRouterContent?.mainMenu.recommendedLinks.link3
                            .link3AriaLabel
                    }
                >
                    {
                        props.helpRouterContent?.mainMenu.recommendedLinks.link3
                            .link3CtaTitle
                    }
                </a>
            </p>
        </div>
    );
};
export default helpRouterPopularLinks;
